<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-房产-修改
    -->
    <el-dialog
    title="修改房产"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改房产</div>

      <el-form-item label="房产名称" prop="name"><el-input v-model="form.name" placeholder="请输入房产名称" class="max-w460"></el-input></el-form-item>
      
      <!-- 新增字段：状态选择 -->
      <el-form-item label="状态" prop="status">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">常住</el-radio>
          <el-radio :label="2">空置</el-radio>
        </el-radio-group>
      </el-form-item>

      <!-- 新增字段：选择管家 -->
      <el-form-item label="管家" :rules="[{required: true,message: '请选择管家'}]">
        <div class="d-s-s d-c">
          <el-button @click="openStaff" icon="el-icon-plus">选择管家</el-button>
          <ul class="d-s-s select-user">
            <li v-if="staff.staff_id" class="mr10 d-c-c d-c p-10-0">
              <img :src="staff.image_url" class="radius" width="30" height="30" />
              <p class="lh18 ww100 text-ellipsis">{{staff.name}}</p>
            </li>
          </ul>
        </div>
      </el-form-item>

      <!-- 新增字段：费用信息 -->
      <el-form-item label="费用信息">
        <div class="fee-container">
          <el-form-item label="物业费用/月" prop="property_fee" class="fee-item">
            <el-input v-model="form.property_fee" placeholder="请输入物业费用" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="水费/月" prop="water_fee" class="fee-item">
            <el-input v-model="form.water_fee" placeholder="请输入水费" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="电费/月" prop="electric_fee" class="fee-item">
            <el-input v-model="form.electric_fee" placeholder="请输入电费" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="车位费/月" prop="parking_fee" class="fee-item">
            <el-input v-model="form.parking_fee" placeholder="请输入车位费" class="max-w200">
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form-item>

      <el-form-item label="房产bannar：" prop="bannar">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.bannar">
          <transition-group>
            <div v-for="(item, index) in form.bannar" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'bannar')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('bannar')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>

      <el-form-item label="房产图片：" prop="image">
      <div class="draggable-list">
        <draggable class="wrapper" v-model="form.image">
          <transition-group>
            <div v-for="(item, index) in form.image" :key="item.file_path">
              <div class="item">
                <img v-img-url="item.file_path" alt="file_path"/>
                <a href="javascript:void(0);" class="delete-btn" @click.stop="deleteImg(index,'album')"><i class="el-icon-close"></i></a>
              </div>
            </div>
          </transition-group>
        </draggable>
        <div class="item img-select" @click="openProductUpload('album')">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </el-form-item>

     
    <el-form-item label="房产介绍">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  

      <el-form-item label="排序" prop="sort"><el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input></el-form-item>
       
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload" @returnImgs="returnProductImgsFunc">上传图片
    </Upload>
    
    <!-- 选择管家组件 -->
    <Staff :storeId="Number(form.staff_id)" :is_open="isOpenStaff"
          :multi="false" @close="closeStaffFunc"></Staff>
  </div>
</el-dialog>
</template>

<script>
import Real_estateApi from '@/api/real_estate.js';
import Upload from '@/components/file/Upload';
import draggable from "vuedraggable";
import Uediter from '@/components/UE.vue';
import Staff from '@/components/user/Staff.vue';

export default {
  components: {
     Upload,
     draggable,
     Uediter,
     Staff
  },
  data() {
    // 费用验证规则
    const validateFee = (rule, value, callback) => {
      if (value && isNaN(value)) {
        callback(new Error('请输入有效的数字'));
      } else if (value && value < 0) {
        callback(new Error('费用不能为负数'));
      } else {
        callback();
      }
    };
    
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        name: '',
        code: 'custom',
        image:[],
        sort:50,
        intro:"",
        bannar:[],
        status: 1, // 1:常住, 2:空置
        staff_id: 0,
        property_fee: '',
        water_fee: '',
        electric_fee: '',
        parking_fee: ''
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入房产名称', trigger: 'blur' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }],
        property_fee: [{ validator: validateFee, trigger: 'blur' }],
        water_fee: [{ validator: validateFee, trigger: 'blur' }],
        electric_fee: [{ validator: validateFee, trigger: 'blur' }],
        parking_fee: [{ validator: validateFee, trigger: 'blur' }]
      },
      dialogVisible:false,
      isProductUpload:false,
      code:"album",
      // 选择用户开关
      isOpenStaff: false,
      staff: {}
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getDetail();
  },
  props: ["open_add","real_estate_id"],
  methods: {
    /*打开获取用户*/
    openStaff() {
      this.isOpenStaff = true;
    },
    
    /*关闭获取用户*/
    closeStaffFunc(e) {
      if (e.type != 'error') {
        this.form.staff_id = e.params.staff_id;
        this.staff = e.params;
      }
      this.isOpenStaff = false;
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    
    cancelFunc() {
      this.dialogFormVisible("error");
    },
    
    getDetail() {
      let self = this;
      Real_estateApi.detail({real_estate_id: self.real_estate_id},true).then(res => {
          self.form = res.data;
          self.ueditor.text = self.form.intro;
          self.isImg = true;
          
          // 初始化新增字段的数据
          if (!self.form.bannar) {
            self.form.bannar = [];
          }
          if (!self.form.image) {
            self.form.image = [];
          }
          if (!self.form.status) {
            self.form.status = 1; // 默认状态为常住
          }
          
          // 如果已有管家信息，初始化管家显示
          if (self.form.staff_id && self.form.staff_name) {
            self.staff = {
              staff_id: self.form.staff_id,
              name: self.form.staff_name,
              image_url: self.form.staff_image || ''
            };
          }
        })
        .catch(error => {});
    },
    
    onSubmit() {
      let self = this;
      let form = self.form;
      
      if(form.image.length <= 0){
        self.$message({
          message: "请上传图片",
          type: 'error'
        });
        return;
      }
      
      form.real_estate_id = self.real_estate_id;
      form.intro = this.$refs.ue.getUEContent();
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Real_estateApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*打开上传图片*/
    openProductUpload: function (code) {
      this.isProductUpload = true;
      this.code = code;
    },

    /*上传商品图片*/
    returnProductImgsFunc(e) {
      if(this.code == 'album'){
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.image.concat(e);
          this.$set(this.form, "image", imgs);
        }
      } else {
        if (e != null) {
          let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
          let prevent = false;
          e.forEach((element) => {
            let data_array = element.file_path.split(".");
            let ext = data_array[data_array.length - 1];
            imgExpt.forEach((e) => {
              if (e === ext) {
                prevent = true;
                return false;
              }
            });
          });

          if (!prevent) {
            this.$message.error("图片类型有误,请选择正确的图片格式");
            return false;
          }

          let imgs = this.form.bannar.concat(e);
          this.$set(this.form, "bannar", imgs);
        }
      }
      
      this.isProductUpload = false;
    },

    /*删除商品图片*/
    deleteImg(index, code) {
      if(code == 'album'){
        this.form.image.splice(index, 1);
      } else if(code == 'bannar'){
        this.form.bannar.splice(index, 1);
      }
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

.draggable-list {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}

.draggable-list .wrapper > span {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.draggable-list .item {
  position: relative;
  width: 110px;
  height: 110px;
  margin-top: 10px;
  margin-right: 10px;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dddddd;
}

.draggable-list .delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background: red;
  line-height: 16px;
  font-size: 16px;
  color: #ffffff;
  display: none;
}

.draggable-list .item:hover .delete-btn {
  display: block;
}

.draggable-list .item img {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  max-height: 100%;
  max-width: 100%;
}

.draggable-list .img-select {
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px dashed #dddddd;
  font-size: 30px;
}

.draggable-list .img-select i {
  color: #409eff;
}

/* 费用信息样式 */
.fee-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.fee-item {
  margin-bottom: 0;
}

.max-w200 {
  max-width: 200px;
}

.select-user {
  margin-top: 10px;
}

.select-user li {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 5px 10px;
  background-color: #f5f7fa;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/real_estate/index/part/edit.vue